// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductShareLink, { ProductShareLinkStyles } from "@insite/content-library/Components/ProductShareLink";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import ShareFill from "@store/Library/Components/Toolkit/Icons/Share/ShareFill";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import HeartPlus from "@store/Library/Components/Icons/HeartPlus";
/* Store Custom Code - End */

const getLinkProps = (src: IconPresentationProps["src"]) => {
    return mergeProps<LinkPresentationProps>(linkGetActionLinkProps(src), {
        css: css`
            ${inlineSeparatorStyles({
                spacing: pxToRem(20), // Store Custom Code
                width: pxToRem(1), // Store Custom Code
                color: "secondary.main", // Store Custom Code
            })}
        `,
    });
};

type Props = WidgetProps & HasProduct;

export interface ProductDetailsActionsStyles {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    listLink?: ProductAddToListLinkStyles;
    shareLink?: ProductShareLinkStyles;
}

export const productDetailsActionsStyles: ProductDetailsActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            ${({ theme }) => {
                const spacing = theme.design.product.detail.contentSpacing;
                return spacingStyles(spacing, spacing);
            }}
        `,
    },
    listLink: {
        link: getLinkProps(HeartPlus), // Store Custom Code
    },
    shareLink: {
        link: getLinkProps(ShareFill),
    },
};

const styles = productDetailsActionsStyles;

const ProductDetailsActions: FC<Props> = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductAddToListLink data-test-selector="productDetails_addToList" extendedStyles={styles.listLink} />
            <ProductShareLink extendedStyles={styles.shareLink} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsActions),
    definition: {
        displayName: "Add to Cart Actions",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        icon: "ellipis",
    },
};

export default widgetModule;
